:host {
  --z-tooltip-theme--surface: var(--color-surface01);
  --z-tooltip-theme--text: var(--color-default-text);
  --z-tooltip-shadow-filter: drop-shadow(0 1px 2px var(--shadow-color-base));
}

:host([dark]) z-popover {
  --z-popover-theme--surface: var(--color-surface05);
  --z-popover-theme--text: var(--color-text-inverse);
}

z-popover {
  --z-popover-padding: var(--space-unit);
  --z-popover-theme--surface: var(--z-tooltip-theme--surface);
  --z-popover-theme--text: var(--z-tooltip-theme--text);
  --z-popover-shadow-filter: var(--z-tooltip-shadow-filter);
}
